var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    width: 32,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD54"
    },
    d: "M512.001,256.006c0,141.395-114.606,255.998-255.996,255.994 C114.606,512.004,0.001,397.402,0.001,256.006C-0.007,114.61,114.606,0,256.005,0C397.395,0,512.001,114.614,512.001,256.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BA41"
    },
    d: "M512.001,256.005c0-1.462-0.086-2.905-0.111-4.362c-0.31-0.317-0.603-0.647-0.94-0.94 c-0.387-0.373-0.729-0.783-1.137-1.137c-0.387-0.373-92.861-92.916-93.27-93.27c-6.682-6.443-16.503-10.167-28.661-10.167H122.195 c-22.4,0-36.318,13.021-36.318,33.988v151.765c0,10.429,3.774,19.057,10.255,25.031c0.375,0.385,0.741,0.771,1.137,1.137 c0.375,0.385,0.741,0.772,1.137,1.137c0.375,0.385,152.02,152.052,152.417,152.417c0.09,0.092,0.182,0.179,0.272,0.272 c1.639,0.031,3.263,0.124,4.91,0.124C397.395,512.004,512.001,397.401,512.001,256.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F6F9"
    },
    d: "M387.881,146.129H122.196c-22.401,0-36.318,13.021-36.318,33.988v151.765 c0,20.331,14.174,33.988,35.269,33.988h266.735c21.802,0,38.242-14.613,38.242-33.988V180.117 C426.123,159.468,411.113,146.129,387.881,146.129z M387.881,160.306c4.002,0,10.879,0.703,16.279,4.255l-142.262,114.38 L107.411,164.03c3.618-2.428,8.496-3.724,14.784-3.724H387.881z M411.947,331.883c0,13.007-12.107,19.811-24.065,19.811H121.147 c-13.207,0-21.092-7.407-21.092-19.811V180.117c0-1.308,0.13-2.501,0.277-3.681L257.84,293.588c1.257,0.934,2.745,1.398,4.229,1.398 c1.574,0,3.147-0.526,4.441-1.565l145.031-116.607c0.151,1.086,0.406,2.069,0.406,3.302L411.947,331.883L411.947,331.883z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.480f1a05964bd2c8e9b44ca2dca2779d.svg";
export { ForwardRef as ReactComponent };